import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ILocale } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";
import { IPickerSearchCriterion } from "ui/shared/helpers/plex-components";
import { IIndustry } from "ui/shared/models/common";

import { ITermDictionaryState, ITermDictionarySearchQuery, getInitialTermDictionaryState, ITermDictionaryEntry, ITranslation } from "./TermDictionary.state";

const initialState = getInitialTermDictionaryState();

export const termDictionary = createSlice({
  name: "termDictionary",
  initialState: initialState,
  reducers: {
    searchLocales: actionProcessing.createWithClearNotification((state: ITermDictionaryState) => {
      return {
        ...state,
        isLoading: true
      };
    }),
    searchLocalesCompleted: actionProcessing.createWithClearNotification(
      (state: ITermDictionaryState, { payload: { locales, searchCriterion } }: PayloadAction<{ locales: ILocale[]; searchCriterion: IPickerSearchCriterion<ILocale> }>) => {
        return {
          ...state,
          isLoading: false,
          filter: { ...state.filter, locales: locales, localesSearchCriterion: searchCriterion }
        };
      }
    ),
    searchLocalesFailed: (state: ITermDictionaryState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        isLoading: false,
        notifications: [action.payload]
      };
    },
    searchIndustries: actionProcessing.createWithClearNotification((state: ITermDictionaryState) => {
      return {
        ...state,
        isLoading: true
      };
    }),
    searchIndustriesCompleted: actionProcessing.createWithClearNotification((state: ITermDictionaryState, action: PayloadAction<IIndustry[]>) => {
      return {
        ...state,
        filter: { ...state.filter, industries: action.payload },
        isLoading: false
      };
    }),
    searchIndustriesFailed: (state: ITermDictionaryState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        isLoading: false,
        notifications: [...state.notifications, action.payload]
      };
    },
    searchTermTranslations: actionProcessing.createWithClearNotification((state: ITermDictionaryState, action: PayloadAction<ITermDictionarySearchQuery>) => {
      return {
        ...state,
        searchQuery: action.payload,
        searchResult: undefined,
        isLoading: true
      };
    }),
    searchTermTranslationsCompleted: actionProcessing.createWithClearNotification((state: ITermDictionaryState, action: PayloadAction<ITranslation[] | ITermDictionaryEntry[]>) => {
      return {
        ...state,
        searchResult: action.payload,
        selectedRowId: "",
        isLoading: false
      };
    }),
    searchTermTranslationsFailed: (state: ITermDictionaryState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        searchResult: undefined,
        notifications: [...state.notifications, action.payload],
        isLoading: false
      };
    },
    toggleSelection: (state: ITermDictionaryState, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedRowId: action.payload
      };
    },
    exportTermTranslations: actionProcessing.createWithClearNotification((state: ITermDictionaryState, action: PayloadAction<ITermDictionarySearchQuery>) => {
      return {
        ...state,
        searchQuery: action.payload
      };
    }),
    exportTermTranslationsFailed: (state: ITermDictionaryState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [...state.notifications, action.payload]
      };
    }
  },
  extraReducers: getScreenExtraReducers<ITermDictionaryState>("notifications", initialState)
});
